
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/perguntas",
      function () {
        return require("private-next-pages/perguntas/index.js");
      }
    ]);
  